/**
 * Utility class for language and internationalization
 */
export class Language {
  private static defaultLanguage = 'en';
  private static currentLanguage = 'en';
  private static supportedLanguages = ['en', 'es'];
  
  /**
   * Get current language
   */
  static getCurrentLanguage(): string {
    return this.currentLanguage;
  }
  
  /**
   * Set current language
   */
  static setCurrentLanguage(lang: string): void {
    if (this.isLanguageSupported(lang)) {
      this.currentLanguage = lang;
      localStorage.setItem('app_language', lang);
    }
  }
  
  /**
   * Check if language is supported
   */
  static isLanguageSupported(lang: string): boolean {
    return this.supportedLanguages.includes(lang);
  }
  
  /**
   * Get language from browser
   */
  static getBrowserLanguage(): string {
    const browserLang = navigator.language.split('-')[0];
    return this.isLanguageSupported(browserLang) ? browserLang : this.defaultLanguage;
  }
  
  /**
   * Initialize language setting
   */
  static initLanguage(): string {
    const savedLang = localStorage.getItem('app_language');
    if (savedLang && this.isLanguageSupported(savedLang)) {
      this.currentLanguage = savedLang;
      return savedLang;
    }
    
    const browserLang = this.getBrowserLanguage();
    this.currentLanguage = browserLang;
    localStorage.setItem('app_language', browserLang);
    return browserLang;
  }
  
  /**
   * Get supported languages
   */
  static getSupportedLanguages(): string[] {
    return [...this.supportedLanguages];
  }
} 